const AUTH_TELEMETRY_FIRED_ID_KEY = "auth-telemetry-fired-id";

export function hasAuthTelemetryFired(telemetryId: string): boolean {
	if (typeof window === "undefined" || !telemetryId) {
		return false;
	}
	try {
		return sessionStorage.getItem(AUTH_TELEMETRY_FIRED_ID_KEY) === telemetryId;
	} catch {
		return false;
	}
}

export function markAuthTelemetryFired(telemetryId: string): void {
	if (typeof window === "undefined" || !telemetryId) {
		return;
	}
	try {
		sessionStorage.setItem(AUTH_TELEMETRY_FIRED_ID_KEY, telemetryId);
	} catch {
		// Storage may be unavailable (e.g. Safari private mode)
	}
}

export function clearAuthTelemetryFired(): void {
	if (typeof window === "undefined") {
		return;
	}
	try {
		sessionStorage.removeItem(AUTH_TELEMETRY_FIRED_ID_KEY);
	} catch {
		// Storage may be unavailable (e.g. Safari private mode)
	}
}
